<template>
  <n-modal class="modal-add" :loading="$var('load')" @close="$emit('close')">
    <h3>Добавить документы</h3>
    <n-form @submit="submit">
      <n-items>
        <n-upload title="Документы" :value.sync="documents" multi />
        <n-button wide type="submit" color="primary">Загрузить</n-button>
      </n-items>
    </n-form>
  </n-modal>
</template>

<script>
export default {
  name: 'ModalAdd',
  props: {
    user: { type: Object, required: true, },
  },
  data() {
    return {
      documents: [],
    }
  },
  methods: {
    submit() {
      this.$var('load', true)

      const apis = $n.reduce(this.documents, (result, file) => {
        result.push($api.users.documents.create(this.user.id, { file, }))
        return result
      }, [])
      Promise.all(apis).then((response) => {
        this.$emit('submit')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-add {

}
</style>
